// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lcStudyListTop {
  display: flex;
  flex-direction: column;
  align-items: start;
  max-width: var(--lc-content-width);
  padding: 0 10px;
  margin: var(--lc-margin-big) auto;
}

.lcStudyListTop p {
  line-height: var(--lc-line-height);
}

.lcStudyListTop code {
  font-size: 16px;
  padding: 3px 6px;
  border: 2px solid #aaa;
  border-radius: 6px;
  background: #eee;
}

.lcStudyListTextArea {
  margin-bottom: var(--lc-margin-medium);
  /* Only allow the textarea to grow vertically */
  width: 100% !important;
  box-sizing: border-box;
  min-height: 300px;
  padding: 20px;
}

.lcStudyListStems {
  width: 100%;
  margin-top: 10px;
}

.lcStudyListStemsRow {
  display: grid;
  grid-template-columns: 70px 0.7fr 1fr 100px 2fr;
  gap: 20px;
  padding: 4px 0;

  &:hover {
    background-color: #6a72fb14;
  }

  &.selected {
    outline: 1px solid var(--lc-accent-color);
    border-radius: 3px;
    background-color: var(--lc-accent-color);
    color: #fff;

    & .lcStudyListButton {
      & {
        outline: 2px solid #fff;
        background-color: var(--lc-accent-color);
        color: #fff;
      }

      &:hover, &:focus {
        background-color: #fff;
        color: rgba(var(--lc-accent-color-rgb), 0.9);
      }
    }
  }
}

.lcStudyListStartButton {
  align-self: center;
}

.lcStudyListStemsCount {
  text-align: right;
}

.lcStudyListButtons {
  display: flex;
  align-items: start;
  gap: 3px;
}

.lcStudyListButton {
  padding: 0.1em 0.4em;
  transition: none;
}

.lcStudyListStemsHeader {
  background-color: #eee;
  color: #888;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: bold;
}

.lcStudyListStemsHeader > div {
  padding: 5px 0;
}

.lcStudyListStemsHeaderRight {
  text-align: right;
}

p.lcStudyListCodes {
  line-height: 2.2;
}

.lcStudyListAddButton {
  font-size: 1em;
}
`, "",{"version":3,"sources":["webpack://./src/frontend/components/LanguageCoach/StudyList.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,+CAA+C;EAC/C,sBAAsB;EACtB,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,SAAS;EACT,cAAc;;EAEd;IACE,2BAA2B;EAC7B;;EAEA;IACE,yCAAyC;IACzC,kBAAkB;IAClB,wCAAwC;IACxC,WAAW;;IAEX;MACE;QACE,uBAAuB;QACvB,wCAAwC;QACxC,WAAW;MACb;;MAEA;QACE,sBAAsB;QACtB,4CAA4C;MAC9C;IACF;EACF;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".lcStudyListTop {\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  max-width: var(--lc-content-width);\n  padding: 0 10px;\n  margin: var(--lc-margin-big) auto;\n}\n\n.lcStudyListTop p {\n  line-height: var(--lc-line-height);\n}\n\n.lcStudyListTop code {\n  font-size: 16px;\n  padding: 3px 6px;\n  border: 2px solid #aaa;\n  border-radius: 6px;\n  background: #eee;\n}\n\n.lcStudyListTextArea {\n  margin-bottom: var(--lc-margin-medium);\n  /* Only allow the textarea to grow vertically */\n  width: 100% !important;\n  box-sizing: border-box;\n  min-height: 300px;\n  padding: 20px;\n}\n\n.lcStudyListStems {\n  width: 100%;\n  margin-top: 10px;\n}\n\n.lcStudyListStemsRow {\n  display: grid;\n  grid-template-columns: 70px 0.7fr 1fr 100px 2fr;\n  gap: 20px;\n  padding: 4px 0;\n\n  &:hover {\n    background-color: #6a72fb14;\n  }\n\n  &.selected {\n    outline: 1px solid var(--lc-accent-color);\n    border-radius: 3px;\n    background-color: var(--lc-accent-color);\n    color: #fff;\n\n    & .lcStudyListButton {\n      & {\n        outline: 2px solid #fff;\n        background-color: var(--lc-accent-color);\n        color: #fff;\n      }\n\n      &:hover, &:focus {\n        background-color: #fff;\n        color: rgba(var(--lc-accent-color-rgb), 0.9);\n      }\n    }\n  }\n}\n\n.lcStudyListStartButton {\n  align-self: center;\n}\n\n.lcStudyListStemsCount {\n  text-align: right;\n}\n\n.lcStudyListButtons {\n  display: flex;\n  align-items: start;\n  gap: 3px;\n}\n\n.lcStudyListButton {\n  padding: 0.1em 0.4em;\n  transition: none;\n}\n\n.lcStudyListStemsHeader {\n  background-color: #eee;\n  color: #888;\n  text-transform: uppercase;\n  font-size: 12px;\n  font-weight: bold;\n}\n\n.lcStudyListStemsHeader > div {\n  padding: 5px 0;\n}\n\n.lcStudyListStemsHeaderRight {\n  text-align: right;\n}\n\np.lcStudyListCodes {\n  line-height: 2.2;\n}\n\n.lcStudyListAddButton {\n  font-size: 1em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
